module.exports = __webpack_public_path__ + "img/rightTop.776dea08.png";